
<template>
  <div>
    <q-layout view="hHh LpR fFf">
      <q-header elevated class="text-white">
        <BarraSuperior />
      </q-header>
      <q-page-container>
        <div
          id="wrapper"
          class="full-width full-height"
        >
          <q-page>
            <router-view />
          </q-page>
        </div>
      </q-page-container>
    </q-layout>
  </div>
</template>
<script>
import { QLayout, QHeader, QPageContainer, QPage } from 'quasar';

import BarraSuperior from '../shared/top-bar/components/BarraSuperior.vue';

export default {
  components: {
    QLayout,
    QHeader,
    QPageContainer,
    BarraSuperior,
    QPage
  },
  created () {}
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 599px) {
  #wrapper {
    padding: 0 0px 20px 0px;
    margin-left: 10px;
  }
}

@media screen and (max-width: 440px) {
  #wrapper {
    padding: 0 0px 10px 0px;
    margin-left: 0px;
  }
}
</style>
